
export const EasingTokens = {
  easeInOut: 'ease-in-out',
  easeOutCubic: 'cubic-bezier(.187, 2.328, .474, .872)',
};
